import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Form from "../../common/forms/Form";
import FormInput from "../../common/forms/FormInput";
import { ValType } from "../../utils/ValidationFunctions";
import formStyles from "../../common/forms/g-formInput.module.scss";
import styles from "./passwordreminder.module.scss";
import { useTranslation } from "react-i18next";
import PageTitle from "../../common/PageTitle";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  requestResetPassword,
  verifyResetPassword,
} from "../../redux/reducers/user";
import {
  RequestStatus,
  getRequestStatus,
  resetRequests,
} from "../../redux/reducers/requests";
import { AuthStatus, getAuthStatus } from "../../redux/reducers/auth";
import MailNonarrival from "../../common/MailNonarrival";

export const PasswordReminderContainer: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [code, setCode] = useState<string>("");
  const [isVerifyPage, setIsVerifyPage] = useState<boolean>(false);

  const requestStatus = useAppSelector(getRequestStatus);
  const auth_status = useAppSelector(getAuthStatus);

  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetRequests());
    };
  }, []);

  const handleRequestSubmit = async () => {
    if (email) {
      const resp = await dispatch(requestResetPassword(email));

      if (resp.meta.requestStatus == "fulfilled") {
        if (resp.payload == true) {
          setIsVerifyPage(true);
          dispatch(resetRequests());
        }
      }
    }
  };

  const handleVerifySubmit = () => {
    if (email && code) {
      dispatch(verifyResetPassword({ email: email, code: code }));
    }
  };

  const handleEmail = (value: string) => {
    setEmail(value);
  };
  const handleCode = (value: string) => {
    setCode(value);
  };

  if (auth_status === AuthStatus.Authenticated) {
    return <Navigate to="/mypage" replace />;
  } else {
    return (
      <PasswordReminder
        email={email}
        isVerifyPage={isVerifyPage}
        requestStatus={requestStatus}
        handleRequestSubmit={handleRequestSubmit}
        handleVerifySubmit={handleVerifySubmit}
        handleEmail={handleEmail}
        handleCode={handleCode}
      />
    );
  }
};

export default PasswordReminderContainer;

type Props = {
  isVerifyPage: boolean;
  requestStatus: string;
  email: string;
  handleRequestSubmit: () => void;
  handleVerifySubmit: () => void;
  handleEmail: (value: string) => void;
  handleCode: (value: string) => void;
};

//ヘッダー未実装
export const PasswordReminder: React.FC<Props> = ({
  isVerifyPage,
  requestStatus,
  email,
  handleRequestSubmit,
  handleVerifySubmit,
  handleEmail,
  handleCode,
}) => {
  const { t } = useTranslation();

  const genRequestAPIMessage = () => {
    switch (requestStatus) {
      default:
      case RequestStatus.Pending:
        return "";
      case RequestStatus.Loading:
        return "メールアドレス確認中です。少々お待ちください..."; //Loading, please wait...
      case RequestStatus.Complete:
        return "入力いただいたメールアドレスに送信された、認証コードを入力してください。"; //An email has been sent to you with a verification code, please check it.
      case RequestStatus.Failed:
        return "エラーが発生しました。メールアドレスを正しく入力したかを確認し、再度お試しください。";
    }
  };

  const genVerifyAPIMessage = () => {
    switch (requestStatus) {
      default:
      case RequestStatus.Pending:
        return "認証コードをお送りしました。\nメールアドレスと認証コードを入力してください。";
      case RequestStatus.Loading:
        return "認証コード確認中です。少々お待ちください...";
      case RequestStatus.Complete:
        return "認証が完了しました。\nご登録のメールアドレスに新しいパスワードを送信しました。\nメールをご確認ください。";
      case RequestStatus.Failed:
        return "エラーが発生しました。メールアドレス/認証コードを正しく入力したかを確認し、再度お試しください。";
    }
  };

  const genMailNonarrivalMessage = () => {
    switch (requestStatus) {
      default:
      case RequestStatus.Pending:
      case RequestStatus.Complete:
        return <MailNonarrival />;
      case RequestStatus.Loading:
      case RequestStatus.Failed:
        return ``;
    }
  };

  if (!isVerifyPage) {
    return (
      <>
        <PageTitle title="Reset Password" subtext="パスワードリセット" />
        <div className={styles["password-reminder"]}>
          <p className={styles["password-reminder__text"]}>
            {t(genRequestAPIMessage())}
          </p>
          <p className={styles["password-reminder__text"]}>
            {t("パスワードリセットのご案内メールをお送りします。")}
            {/* {t("パスワードを忘れた方は、")} */}
            {/* <br className={styles["password-reminder__text__pc-layout"]} /> */}
            <br />
            {t("登録時のメールアドレスを入力してください。")}
            {/* <br></br> */}
          </p>
          <Form
            handler={handleRequestSubmit}
            button_id="submit_button"
            button_text="メールを送信"
            button_class={formStyles["g-button"]}
          >
            <div className={formStyles["g-form__wrapper"]}>
              <FormInput
                label="メールアドレス"
                type="textBeforeLabel"
                name="sonic_email"
                val_type={ValType.NotNull}
                placeholder="メールアドレス"
                id="sonic_email"
                handler={handleEmail}
                style_class={formStyles["g-form__input"]}
                label_class={formStyles["g-form__label"]}
              />
            </div>
          </Form>
        </div>
      </>
    );
  } else {
    return (
      <>
        <PageTitle title="Verify Reset Password" subtext="認証コードの確認" />
        <div className={styles["password-reminder"]}>
          <div className={styles["password-reminder__text"]}>
            {t(genVerifyAPIMessage())}
            {genMailNonarrivalMessage()}
          </div>

          {requestStatus != RequestStatus.Complete ? (
            <Form
              handler={handleVerifySubmit}
              button_id="submit_button"
              button_text="パスワードをリセットする"
              button_class={formStyles["g-button"]}
            >
              <div className={formStyles["g-form__wrapper"]}>
                <FormInput
                  label="メールアドレス"
                  type="textBeforeLabel"
                  name="sonic_email"
                  val_type={ValType.NotNull}
                  placeholder="メールアドレス"
                  id="sonic_email"
                  handler={handleEmail}
                  style_class={formStyles["g-form__input"]}
                  label_class={formStyles["g-form__label"]}
                  initial_value={email}
                />
              </div>
              <div className={formStyles["g-form__wrapper"]}>
                <FormInput
                  label="認証コード"
                  type="textBeforeLabel"
                  name="sonic_code"
                  val_type={ValType.NotNull}
                  placeholder="メールアドレス"
                  id="sonic_code"
                  handler={handleCode}
                  style_class={formStyles["g-form__input"]}
                  label_class={formStyles["g-form__label"]}
                />
              </div>
            </Form>
          ) : null}
        </div>
      </>
    );
  }
};
